/* ====== MAIN PDP LEAD TIME, DROPDOWN LEADTIME TEXT & NOTIFY ME POPUP FUNCTIONALITY HANDLER'S ====== */

(function () {
  /* ====== Config & State ====== */
  const SECTION_ID = document.querySelector('[id^="LeadTimeMsg-"]')?.id.replace('LeadTimeMsg-', '');
  const productTags = window.currentProductJson ? window.currentProductJson.tags.join(',') : '';
  const hiddenLeadtimeOptions = ["I don't know my size; send me a Ring Sizing Gauge!", "I don't know my size; send me a Ring Sizing Gauge!" , "Send Ring Sizer", "Need Help With Size", "IDKMS", "I don't know my size;"];
  // Product templates that show exact quantity ("Only X left in stock!") instead of generic messages
  const LIMITED_QTY_TEMPLATES = [
    'limited-quantity-pdp',
    'bespoke-flash-product',
    'bespok-flash-product-meta',
    'bespoke-duchess-products',
    'sold-out-er-build-your-ow',
    'sold-out-er-customize'
  ];
  // Cache: variantId -> availableToSell + inventory_management
  const variantDataCache = {};
  // Cache: variantId -> customLeadTime, pre-populated at load from window.variantLeadTimeMap
  // (see rc-leadtime-integration.liquid), so every variant's text is known instantly -
  // no waiting on any server round-trip, ever.
  const customLeadTimeCache = Object.assign({}, window.variantLeadTimeMap || {});

  /* ====== Helper: resolve in-stock lead time message by template ====== */
  function resolveInStockMessage(qty) {
    const currentTemplate = window.currentProductTemplate || '';
    const isLimitedTemplate = LIMITED_QTY_TEMPLATES.includes(currentTemplate);
    if (isLimitedTemplate) {
      // Both > 30 and <= 30 show exact quantity for these templates
      return { message: `Only ${qty} left in stock!`, swatchMessage: 'In Stock', swatchClass: 'rc-swatch--green' };
    }
    // Generic templates
    if (qty <= 30) {
      return { message: 'Only a few left!', swatchMessage: 'In Stock', swatchClass: 'rc-swatch--green' };
    }
    return { message: 'In Stock', swatchMessage: 'In Stock', swatchClass: 'rc-swatch--green' };
  }

  /* ====== Render Lead Time UI ====== */
  function renderLeadTime({ availableToSell, customLeadTime, oversellAllowed, inventory_management, sectionId }) {
    const isLocketCharm = productTags.includes('locket-charms');
    const suffix = isLocketCharm ? '-locket-charms' : '';
    const container = document.getElementById(`rc-leadtime-display${suffix}`);
    const swatchContainer = document.getElementById(`rc-leadtime-swatch${suffix}`);

    /* ======= Hide lead time for IDKMS / hidden leadtime variants ======= */
    const variantTitle = window.selectedVariantJson?.title || '';
    if (hiddenLeadtimeOptions.some(hidden => variantTitle.includes(hidden))) {
      if (container) container.hidden = true;
      if (swatchContainer) swatchContainer.hidden = true;
      return;
    }

    /* ======= IN STOCK RINGS: Bespoke product functionality for Leadtime ======= */
    const isBespokeProduct = productTags?.includes('show-bespoke-flash-product');
    const hasInstockLogic = productTags?.includes('fetch-oms-leadtime-in-stock');

    if (!container) return;

    // Determine message & swatch state
    const isTracked = !!inventory_management;

    let message, swatchMessage, swatchClass;

    if (!isTracked) {
      if (customLeadTime) {
        [message, swatchMessage, swatchClass] = [customLeadTime, 'Made to Order', 'rc-swatch--orange'];
      } else {
        [message, swatchMessage, swatchClass] = ['In Stock', 'In Stock', 'rc-swatch--green'];
      }
    } else if (availableToSell <= 0) {
      if (!oversellAllowed) {
        // sold out — show explicit Sold Out message instead of hiding
        [message, swatchMessage, swatchClass] = ['Sold Out', '', ''];
      } else {
        [message, swatchMessage, swatchClass] = [customLeadTime || 'Available to order', 'Made to Order', 'rc-swatch--orange'];
      }
    } else {
      // Tracked + in stock: resolve message based on qty & product template
      ({ message, swatchMessage, swatchClass } = resolveInStockMessage(availableToSell));
    }

    /* ======= Update Lead Time for Bespoke product ======= */
    if (isBespokeProduct && hasInstockLogic) {
      [message, swatchMessage, swatchClass] = ['Only 1 left in stock!', 'In Stock', 'rc-swatch--green'];
    }

    // Update lead time container
    container.textContent = message;
    container.hidden = false;

    // Grabbing & Storing leadtime message text in a global variable
    originalLeadTime = message;

    const engravingToggleEl = sectionId ? document.getElementById(`engraving-toggle-${sectionId}`) : null;
    const savedState = sectionId ? window.__rcEngravingToggleState?.[sectionId] : undefined;
    const isEngravingOn = typeof savedState === 'boolean' ? savedState : !!engravingToggleEl?.checked;

    if (typeof window.__rcUpdateEngravingLeadTime === 'function') {
      window.__rcUpdateEngravingLeadTime(isEngravingOn ? 'turned_on' : 'turned_off');
    }

    /* ===== Update Charm Stone Count Dropdown Leadtime : Locket Charm ==== */
    if (isLocketCharm) {
      var customStoneDrop = $('.rc-locket-charm-drop-lead');
      message && message === 'In Stock' ? customStoneDrop.text('In Stock') : customStoneDrop.text('Made to Order');
    }

    // Update swatch container
    if (swatchContainer) {
      if (swatchMessage) {
        swatchContainer.innerHTML = isLocketCharm
          ? `<span class="rc-swatch__dot"></span>`
          : `<span class="rc-swatch__dot"></span>${swatchMessage}`;
        swatchContainer.className = `rc-swatch ${swatchClass}`;
        swatchContainer.hidden = false;
      } else {
        swatchContainer.hidden = true;
      }
    }

    /* ===== Hide Leadtime for Locket Charm product if it's "In Stock" ==== */
    if (isLocketCharm && message === 'In Stock') {
      container.classList.add('is-hide');
      if (swatchContainer) swatchContainer.hidden = true;
      return;
    }
  }

  /* ====== Show / Hide Notify Me Popup ====== */
  function showNotifyMeMessage({ availableToSell, inventory_management, inventory_policy, variantId, isVariantLeadMessage }) {
    const productId = window.currentProductJson?.id;
    const $popup = $('#notifyWhenInStockPopup');

    const shouldShowPopup =
      inventory_management &&
      inventory_policy === 'deny' &&
      availableToSell <= 0 &&
      !isVariantLeadMessage &&
      productTags.indexOf('dont-show-in-stock-popup') === -1;

    if (shouldShowPopup) {
      $popup.find('.js-productId').val(productId);
      $popup.find('.js-variant').val(variantId);
      $popup.show();
      $('.flyout-card').hide();
    } else {
      $popup.find('.js-productId').val('');
      $popup.find('.js-variant').val('');
      $popup.hide();
      $('.ProductForm__AddToCart').show();
      $('.flyout-card').show();
    }
  }

  /* ====== Save user to Notify API (called from Liquid form onsubmit) ====== */
  window.saveUserInNotifyApi = function () {
    try {
      const $popup = $('#notifyWhenInStockPopup');
      const productId = $popup.find('.js-productId').val();
      const variantId = $popup.find('.js-variant').val();
      const email = $popup.find('.js-email').val();

      if (productId && variantId && email) {
        $.ajax({
          url: `${portalApiUrl}/notify`,
          type: 'POST',
          data: { productId, variantId, email },
          success: function () {
            $popup.find('.apiResponseMessage').html(`<p>Thank you! We'll let you know when this product has been restocked.</p>`);
            $popup.find('button').text("YOU'RE ON THE LIST");
            setTimeout(function () {
              window.location.reload();
            }, 10000);
          },
          error: function () {
            $popup.find('.apiResponseMessage').html('<p class="Form__Alert Alert Alert--error">Some Error occurred</p>');
          }
        });
      }
      return false;
    } catch (error) {
      console.log('An error occurred:', error);
    }
  };

  /* ====== Process variant using cache ====== */
  function processVariant(variantId, oversellAllowed, customLeadTime, sectionId) {
    if (!variantId) return;

    const cached = variantDataCache[variantId];
    if (!cached) return;

    renderLeadTime({
      availableToSell: cached.availableToSell,  // from API
      oversellAllowed,                          // from variant object
      customLeadTime,                           // from metafield span
      inventory_management: cached.inventory_management, // from API
      sectionId
    });

    // 2. Show/hide notify me popup
    const isVariantLeadMessage = oversellAllowed && !!customLeadTime;

    showNotifyMeMessage({
      availableToSell: cached.availableToSell,
      inventory_management: cached.inventory_management,
      inventory_policy: oversellAllowed ? 'continue' : 'deny',
      variantId,
      isVariantLeadMessage
    });
  }

  /* ====== Fetch all variant data once ====== */
  async function fetchAndCacheVariantData() {
    const productJson = window.currentProductJson;
    if (!productJson) {
      console.warn('[LeadTime] currentProductJson not found on window');
      return;
    }
    try {
      const response = await fetch(`${portalApiUrl}/mongo/leadtime?shopifyProductId=${productJson.id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);

      const json = await response.json();

      // Cache availableToSell + inventory_management from API
      json.data.forEach((item) => {
        variantDataCache[String(item.id)] = {
          availableToSell: item.availableToSell ?? 0,
          inventory_management: item.inventory_management ?? null
        };
      });

      // On landing — read oversell + customLeadTime from Liquid-injected variant
      const selectedVariant = window.selectedVariantJson;
      if (selectedVariant) {
        const oversellAllowed = selectedVariant.inventory_policy === 'continue';
        const customLeadTime = document.getElementById(`LeadTimeMsg-${SECTION_ID}`)?.dataset.leadTime || '';
        processVariant(selectedVariant.id, oversellAllowed, customLeadTime);
        processVariant(selectedVariant.id, oversellAllowed, customLeadTime, SECTION_ID);
        renderDropdownLeadtime();
      }

    } catch (err) {
      console.error('[LeadTime] Failed to fetch variant data:', err);
    }
  }

  /* ====== Update Lead time on Variant change ====== */
  webvista.subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const { sectionId, html, variant } = data;

    // --- Instant pass (html is null): render immediately for zero perceived delay ---
    if (!html) {
      if (!variant) return;

      const oversellAllowed = variant.inventory_policy === 'continue';
      // customLeadTimeCache is pre-populated for every variant at page load
      // (see window.variantLeadTimeMap), so this is always correct instantly -
      // no need to wait on the server. DOM fallback only applies if a variant
      // is somehow missing from the map (e.g. metafield truly blank).
      const targetMsgLeadTime = document.getElementById(`LeadTimeMsg-${sectionId}`);
      const customLeadTime =
        customLeadTimeCache[variant.id] ??
        targetMsgLeadTime?.dataset.leadTime ??
        '';

      window.selectedVariantJson = variant;
      processVariant(variant.id, oversellAllowed, customLeadTime, sectionId);
      renderDropdownLeadtime();
      return;
    }

    // --- Full pass (html is present): confirm/correct with server data ---
    const sourceMsgLeadTime = html.getElementById(`LeadTimeMsg-${sectionId}`);
    const targetMsgLeadTime = document.getElementById(`LeadTimeMsg-${sectionId}`);
    if (sourceMsgLeadTime && targetMsgLeadTime) {
      targetMsgLeadTime.dataset.leadTime = sourceMsgLeadTime.dataset.leadTime;
    }

    const oversellAllowed = variant?.inventory_policy === 'continue';
    const customLeadTime = targetMsgLeadTime?.dataset.leadTime || '';

    // Remember this variant's confirmed lead time for future instant passes
    if (variant?.id) {
      customLeadTimeCache[variant.id] = customLeadTime;
    }

    window.selectedVariantJson = variant;
    processVariant(variant.id, oversellAllowed, customLeadTime, sectionId);
    renderDropdownLeadtime();
  });

  /* ====== Notify Form UX ====== */
  $(".rc-notify-container .rc-form-control").on("click", function () {
    $('.rc-notify-form .Button--secondary').removeAttr("disabled");
    $('.rc-notify-form .form-label').removeClass("hidden");
  });
  $(".rc-notify-container .rc-form-control").on("blur", function () {
    if ($(this).val() === '') {
      $('.rc-notify-form .Button--secondary').prop('disabled', true);
      $('.rc-notify-form .form-label').addClass("hidden");
    }
  });

  function renderDropdownLeadtime() {
    const product = window.currentProductJson;
    const selectedVariant = window.selectedVariantJson;
    if (!product || !selectedVariant) return;

    const dropdowns = document.querySelectorAll('.custom-dropdown__list');

    // Build a map of selectId -> optionIndex for all dropdowns
    const dropdownOptionMap = [];

    dropdowns.forEach((dropdown) => {
      const selectId = dropdown.closest('.custom-dropdown')?.dataset.selectId;
      const linkedSelect = selectId ? document.getElementById(selectId) : null;
      const optionName = linkedSelect?.name?.replace('options[', '').replace(']', '');
      const optionIndex = product.options.findIndex((name) => name === optionName);
      dropdownOptionMap.push({ dropdown, optionIndex });
    });

    // Find the highest valid optionIndex among all dropdowns
    const maxOptionIndex = Math.max(...dropdownOptionMap.map((d) => d.optionIndex));

    // Only process the dropdown(s) that match the last option index
    dropdownOptionMap.forEach(({ dropdown, optionIndex }) => {

      // ONLY append labels on the last variant option dropdown
      if (optionIndex !== maxOptionIndex) return;

      // Grab all dropdown option which do not includes rc-custom-variant class because that's custom so we don't have to show leadtime
      const options = dropdown.querySelectorAll('.custom-dropdown__option:not(.rc-custom-variant)');

      options.forEach((optionEl) => {
        optionEl.querySelector('.rc-avail-label')?.remove();

        const optionValue = optionEl.dataset.value;
        if (!optionValue) return;

        // Hide leadtime for specific options
        if (hiddenLeadtimeOptions.includes(optionValue.trim())) return;

        const matchOptions = [
          selectedVariant.option1,
          selectedVariant.option2,
          selectedVariant.option3,
        ];
        matchOptions[optionIndex] = optionValue;

        const matchedVariant = product.variants.find((variant) => {
          if (matchOptions[0] && variant.option1 !== matchOptions[0]) return false;
          if (matchOptions[1] && variant.option2 !== matchOptions[1]) return false;
          if (matchOptions[2] && variant.option3 !== matchOptions[2]) return false;
          return true;
        });

        if (!matchedVariant) return;

        const cached = variantDataCache[String(matchedVariant.id)];
        if (!cached) return;

        const qty = Number(cached.availableToSell ?? 0);
        const oversell = matchedVariant.inventory_policy === 'continue';
        // Check inventory_management — if not tracked, Show custom leadtime with Made to order
        const isTracked = !!cached.inventory_management;

        let label, className;
        if (!isTracked) {
          label = 'Made to Order';
          className = 'made-to-order';
        } else if (qty > 0) {
          label = 'In Stock';
          className = 'in-stock';
        } else if (oversell) {
          label = 'Made to Order';
          className = 'made-to-order';
        } else {
          label = 'Sold Out';
          className = 'sold-out';
        }

        optionEl.insertAdjacentHTML(
          'beforeend',
          `<span class="rc-avail-label rc-avail-label--${className}">${label}</span>`
        );
      });
    });
  }

  /* ====== Init ====== */
  fetchAndCacheVariantData();

})();